/* eslint-disable camelcase */
import { feetToInches, isset } from "legacy/helpers.es6"

export default function buildPricingRequestPayload(state) {
  const {
    loa,
    beam,
    dockType,
    arrival,
    departure,
    boatId,
    electric_id,
    promoCode,
    referralCode,
    fullName,
    email,
    phone,
    choseBoatUS,
    boatUSMemberID,
    boatUSZipCode,
    boatUSLastName,
    verifiedBrewer,
    brewerMemberID,
    firstName,
    lastName,
  } = state

  const [parsedFirstName, ...parsedLastNameParts] = (fullName || "")
    .trim()
    .split(" ")

  const payload = {
    length_overall: feetToInches(loa),
    beam: feetToInches(beam),
    requested_space_type: dockType,
    check_in_date: arrival,
    check_out_date: departure,
    contact: {
      first_name: parsedFirstName,
      last_name: parsedLastNameParts.join(" "),
      email,
      phone,
    },
  }

  if (isset(boatId)) {
    payload.boat_id = boatId
  }

  if (isset(electric_id)) {
    payload.electrical_rate_id = electric_id
    payload.electric_product_id = electric_id
  }

  if (isset(promoCode)) {
    payload.promo_code_id = promoCode.id
  }

  if (isset(referralCode)) {
    payload.referral_code_id = referralCode.id
  }

  if (choseBoatUS) {
    payload.contact.boatus_id = boatUSMemberID
    payload.contact.boatus_zip = boatUSZipCode
    payload.contact.boatus_last_name = boatUSLastName
  }

  if (verifiedBrewer) {
    payload.contact.brewer_id = brewerMemberID
    payload.contact.first_name = firstName
    payload.contact.last_name = lastName
  }

  return payload
}
